export default __webpack_public_path__ + "static/media/woods.3ff01cfe.png";